
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-map-pin-line',
      title: 'MEO対策',
      subtitle: '「見つけてもらう」から「選ばれる」へ',
      description: 'Googleマップでの露出を高め、地域のお客様に選ばれる店舗づくりをサポートします。ビジネスプロフィールの最適化、口コミ対応、キーワード分析などを通して、"地域での認知拡大"と"来店動線の確立"を実現。ただ順位を上げるだけでなく、お客様が安心して選べる情報発信を重視しています。',
      image: 'https://public.readdy.ai/ai/img_res/b8ff39aa515f79aabaaa1095b9908cf0.jpg',
      features: [
        'Googleビジネスプロフィールの最適化・投稿管理',
        'キーワードリサーチと順位レポート',
        '口コミ・レビュー戦略の設計と運用',
        'マップ検索からの導線改善（Web・電話・来店）'
      ]
    },
    {
      icon: 'ri-line-chart-line',
      title: 'デジタル広告',
      subtitle: '地域の魅力を、必要な人へ届ける',
      description: 'Google・Instagram・Facebook広告を活用し、「地域の強み」を効果的に伝える広告設計を行います。広告を"売り込み"ではなく、"価値を伝えるコミュニケーション"として設計。分析データを基に、最小コストで最大の成果を目指します。',
      image: 'https://readdy.ai/api/search-image?query=Digital%20advertising%20dashboard%20showing%20Google%20Ads%2C%20Instagram%20and%20Facebook%20advertising%20interfaces%2C%20local%20business%20targeting%2C%20professional%20analytics%20visualization%2C%20clean%20modern%20design%2C%20business%20growth%20concept%2C%20regional%20marketing%20focus&width=500&height=400&seq=ads3&orientation=landscape',
      features: [
        'リスティング広告・ディスプレイ広告の運用代行',
        'Meta（Instagram/Facebook）広告の配信設計',
        '広告データ分析・効果改善レポート',
        'ランディングページ改善・A/Bテスト提案'
      ]
    },
    {
      icon: 'ri-user-settings-line',
      title: 'コンサルティング',
      subtitle: '戦略設計から運用まで、伴走支援',
      description: '地域ビジネスの成長には、単発ではなく"継続的な改善"が欠かせません。私たちは、経営者・現場担当者と一緒に戦略を考え、集客からリピート獲得までの仕組みを共に作ります。データを活かした「現状分析」と「改善提案」で、中長期的なマーケティング基盤を強化します。',
      image: 'https://readdy.ai/api/search-image?query=Business%20hands%20working%20on%20marketing%20strategy%20documents%2C%20data%20analysis%20charts%20on%20desk%2C%20professional%20consultation%20materials%2C%20collaborative%20planning%20session%2C%20modern%20office%20desk%20view%2C%20clean%20business%20photography%2C%20hands%20only%20visible%2C%20no%20faces%20shown&width=500&height=400&seq=consulting2&orientation=landscape',
      features: [
        'マーケティング戦略の立案・設計',
        '既存データの分析と課題抽出',
        'チーム育成・運用サポート（SNS・MEO・広告）',
        '定例ミーティング・改善提案レポートの提供'
      ]
    }
  ];

  return (
    <section id="services" className="py-20 bg-[#F4F9FF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-blue-600 font-medium text-sm uppercase tracking-wide mb-2">SERVICES</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            マーケティングソリューション
          </h2>
          <div className="text-xl text-gray-600 max-w-3xl mx-auto text-left md:text-center">
            <p className="mb-2 leading-tight">
              最新のデジタルマーケティング手法を駆使し、
            </p>
            <p className="leading-tight">
              お客様のビジネス成長をトータルサポートいたします。
            </p>
          </div>
        </div>

        <div className="space-y-20">
          {services.map((service, index) => (
            <div 
              key={index} 
              className={`flex flex-col lg:flex-row items-center gap-12 ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              {/* 画像部分 */}
              <div className="w-full lg:w-1/2">
                <div className="relative overflow-hidden rounded-2xl shadow-lg">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-80 object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
              </div>

              {/* テキスト部分 */}
              <div className="w-full lg:w-1/2">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    <i className={`${service.icon} text-xl text-blue-600`}></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900">{service.title}</h3>
                    <p className="text-lg text-blue-600 font-medium">{service.subtitle}</p>
                  </div>
                </div>
                
                <p className="text-gray-700 leading-relaxed mb-8 text-lg text-left">
                  {service.description}
                </p>

                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">主な支援内容</h4>
                  <ul className="space-y-3">
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-start">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* お問い合わせボタン */}
        <div className="text-center mt-16">
          <a 
            href="#contact"
            className="inline-flex items-center px-8 py-4 bg-blue-600 text-white font-semibold rounded-[10px] hover:bg-blue-700 hover:scale-105 hover:shadow-lg transform transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line text-xl mr-3"></i>
            お問い合わせはこちら
          </a>
        </div>
      </div>
    </section>
  );
}
